import { GapChaseFilterBase, filterType, dataType } from '../GapChaseFilterBase';

export default class RAFOpportunityIncreaseFilter extends GapChaseFilterBase {
    constructor() {
        super();
        this.id = 50;
        this.name = "RAF Opportunity Increase";
        this.filterName = "RAFOpportunityIncrease";

        // The following two lines make this filter LOB aware
        const validFilterLOBs = ["Medicare"];
        this.isHidden = validFilterLOBs.indexOf(localStorage.getItem('Lob')) < 0;

        this.filterType = filterType.text;
        this.values = [];

        this.dataType = dataType.number;
        this.filterCategory = "Member Level";
        this.filterGroupId = 2;
        this.maxValue = 1000;
        this.placeholder = "RAF Opportunity Increase";
    }
}
